<template>
  <a-modal v-model="visible" title="变更初次邀请入会经理和时间" @ok="handleOk" @cancel="handleClose" :confirmLoading="confirmLoading"
    :maskClosable="false">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="初次邀约销售" prop="user_id">
        <a-select v-model="form.first_joinuser" style="width: 100%" placeholder="请选择" option-label-prop="label"
          :filter-option="filterOption">
          <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id" :label="v.real_name">
            {{ v.real_name }}
            <span role="img" :aria-label="v.real_name" style="font-size: 14px; color: #888">
              ({{ v.department.department_name }})
            </span>
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="初次入会日期">
        <a-date-picker show-time style="width: 100%;" :format="'YYYY/MM/DD HH:mm:ss'" :valueFormat="'YYYY/MM/DD HH:mm:ss'"
          v-model="form.first_jointime" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      customerShareList: [],
      form: {
        customer_id: "",
        first_joinuser: "",
        first_jointime: undefined,
      },
      rules: {
        first_joinuser: {
          required: true,
          message: "请选择销售",
          trigger: "change",
        },
      },
      userList: [],
      labelCol: { span: 7 },
      wrapperCol: { span: 14 },
    };
  },
  methods: {
    init(customer_id) {
      this.form.customer_id = customer_id;
      this.$http({
        url: '/admin/customer/info',
        method: 'post',
        data: { id: customer_id }
      }).then(res => {
        this.form.first_joinuser = res.data.first_joinuser
        this.form.first_jointime = res.data.first_jointime
      })
      this.visible = true;
      this.getUserList();
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getUserList() {
      this.$http({
        url: "/admin/user/page?page=1&limit=200",
        method: "get",
      }).then((res) => {
        this.userList = res.data.result;
      });
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: "/admin/customer/changefirstmanager",
            method: "post",
            data: this.form,
          })
            .then(() => {
              this.$message.success("修改成功");
              this.handleClose();
              this.$emit("ok");
            })
            .finally(() => (this.confirmLoading = false));
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose() {
      this.$refs.ruleForm.resetFields();
      this.visible = false;
    },
  },
};
</script>

<style></style>